import styles from './Header.module.scss';
import logo from '/assets/logo.svg';
import { Container } from '../Container/Container';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Menu } from './Menu/Menu';
import { Image } from '../Image/Image';
import cn from 'classnames';
export const Header = ({style, nextSlug}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  }
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll);
    // cleanup
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const showBurgerMenu = location.pathname === '/';
  let styleClass;
  switch (style) {
    case 'white':
      styleClass = styles.white;
      break;
    case 'orange':
      styleClass = styles.white;
      break;
  }
  return (
    <header className={cn(
      styles.header,
      styleClass,
      scrolled && styles.scrolled
      )}>
      <Container className={styles.container}>
        {logo && <div className={styles.logo}><Image src={logo} /></div>}
        {showBurgerMenu && (
          <div
            className={`${styles.burgerMenu} ${isOpen ? styles.active : ''}`}
            onClick={toggleMenu}
          >
            <span></span>
          </div>

        )}
        {nextSlug &&
          <div className={styles.skip} onClick={()=>{navigate(nextSlug)}}>skip</div>
        }
        {isOpen && (
          <Menu />
        )}
      </Container>

    </header >
  )
}
